import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { intlShape, injectIntl } from 'react-intl';
import {
  Modal,
  ModalButtons,
  ModalContent,
  Button,
  ProgressBar,
  withForm,
  Label,
  TextField,
  Checkbox,
  Upload,
  Avatar,
  Icon,
} from 'mw-style-react';
import AppUtils from '@control-front-end/utils/utils';
import Yup from 'yup';
import { CREATE_CREDENTIAL, UPLOAD_FILE, UPDATE_CREDENTIAL } from 'constants';
import mes from './intl';
// eslint-disable-next-line no-unused-vars
import sModal from '../../Modal.scss'; // NOSONAR
// eslint-disable-next-line no-unused-vars
import sLocal from './CreateCredential.scss'; // NOSONAR

class CreateCredential extends PureComponent {
  constructor(props) {
    super(props);
    this.handleOnUploadImageChange = this.handleOnUploadImageChange.bind(this);
    this.handleOnScopeChange = this.handleOnScopeChange.bind(this);
  }

  // Ф-ция локализации
  i(mesId, values) {
    return AppUtils.getMes(this.context)(mesId, values);
  }

  handleOnUploadImageChange({ value }) {
    const { dispatch, handleOnChange } = this.props;
    dispatch({
      type: UPLOAD_FILE.REQUEST,
      payload: {
        files: value,
        callback: (attachments) => {
          handleOnChange({
            id: 'photo',
            value: AppUtils.makeAppUrl(`/download/${attachments[0].fileName}`),
          });
        },
      },
    });
  }

  handleOnScopeChange({ id, value }) {
    const { values, handleOnChange } = this.props;
    const selectedScope = values.scope.slice();

    const index = selectedScope.indexOf(id);
    // добавить
    if (value && index === -1) {
      selectedScope.push(id);
    }
    // удалить
    if (!value && index !== -1) {
      selectedScope.splice(index, 1);
    }
    handleOnChange({ id: 'scope', value: selectedScope });
  }

  render() {
    const {
      values,
      data,
      errors,
      credentials,
      visibility,
      onClose,
      handleSubmit,
      handleOnChange,
      isSubmit,
    } = this.props;
    const editMode = data && data.id;
    return (
      <Modal
        styleName="sModal.modal"
        visibility={visibility}
        onClose={onClose}
        label={
          editMode ? this.i(mes.updateCredential) : this.i(mes.createCredential)
        }
        size="large"
      >
        <ModalContent styleName="sModal.modal__content sLocal.modal__content">
          <div styleName="sLocal.row">
            <div styleName="sLocal.row__upload">
              {!values.photo ? (
                <Icon
                  styleName="sLocal.row__upload__camera"
                  type="camera"
                  size="medium"
                />
              ) : null}
              <Avatar
                styleName="sLocal.row__upload__avatar"
                size="large"
                src={values.photo ? values.photo : null}
              />
              <Upload
                id="photo"
                accept="image/*"
                onChange={this.handleOnUploadImageChange}
              >
                <Button
                  type="quaternary"
                  size="smallplus"
                  fontWeight="normal"
                  label={this.i(mes.uploadImage)}
                />
              </Upload>
            </div>
          </div>
          <div styleName="sLocal.row">
            <div>
              <Label value={this.i(mes.webhookUrl)} fontWeight="semibold" />
              &nbsp;
              <Label
                value={this.i(mes.webhookInfo)}
                styleName="sLocal.row__label__disabled"
              />
            </div>
            <TextField
              styleName="sModal.textfield sLocal.row__field"
              id="webhook"
              autoFocus={true}
              label=""
              placeholder={this.i(mes.webhookPlaceholder)}
              bordered={true}
              size="large"
              value={values.webhook || ''}
              helperText={errors.webhook ? this.i(mes[errors.webhook]) : ''}
              error={!!errors.webhook}
              onChange={handleOnChange}
            />
          </div>
          <div styleName="sLocal.row">
            <div>
              <Label value={this.i(mes.enterKeyName1)} fontWeight="semibold" />
              &nbsp;
              <Label
                value={this.i(mes.enterKeyName2)}
                styleName="sLocal.row__label__disabled"
              />
            </div>
            <TextField
              styleName="sModal.textfield sLocal.row__field"
              id="title"
              label=""
              placeholder={this.i(mes.enterKeyNamePlaceholder)}
              bordered={true}
              size="large"
              length={50}
              value={values.title || ''}
              helperText={errors.title ? this.i(mes[errors.title]) : ''}
              error={!!errors.title}
              onChange={handleOnChange}
            />
          </div>
          <div styleName="sLocal.row">
            <div styleName="sLocal.row__label">
              <Label value={this.i(mes.scopes1)} fontWeight="semibold" />
              &nbsp;
              <Label
                value={this.i(mes.scopes2)}
                styleName="sLocal.row__label__disabled"
              />
              {errors.scope ? (
                <Label
                  styleName="sLocal.row__label__helper"
                  value={this.i(mes[errors.scope])}
                  fontSize="small"
                  error={true}
                />
              ) : null}
            </div>
            <div styleName="sLocal.row__container">
              {credentials.scope.map((i, index) => (
                <Checkbox
                  styleName="sLocal.row__check"
                  key={index}
                  id={i.name}
                  value={values.scope.includes(i.name)}
                  onChange={this.handleOnScopeChange}
                  error={!!errors.scope}
                  visibility={editMode ? 'disabled' : 'visible'}
                >
                  <div styleName="sLocal.row__check__item">
                    <Label
                      styleName="sLocal.row__check__item__label"
                      fontWeight="semibold"
                      value={i.name}
                    />
                    <Label
                      styleName="sLocal.row__label__disabled"
                      value={i.description}
                    />
                  </div>
                </Checkbox>
              ))}
            </div>
          </div>
        </ModalContent>
        <ModalButtons styleName="sModal.modal__buttons">
          <Button
            label={editMode ? this.i(mes.update) : this.i(mes.create)}
            size="large"
            onClick={handleSubmit}
            visibility={isSubmit ? 'disabled' : 'visible'}
          />
          <ProgressBar
            styleName="sModal.modal__loader"
            type="circle"
            size="small"
            visibility={isSubmit ? 'visible' : 'hidden'}
          />
        </ModalButtons>
      </Modal>
    );
  }
}

const FormContactUs = withForm(
  {
    mapPropsToValues(props) {
      const formData = props.data || {};
      return {
        title: formData.title,
        webhook: formData.webhook,
        photo: formData.photo,
        scope: formData.scope || [],
      };
    },
    yup: Yup.object().shape({
      title: Yup.string()
        .matches(/^[a-zA-z0-9\s]{3,}$/, 'wrong_format')
        .required('field_required'),
      webhook: Yup.string().required('field_required').url('valid_url'),
      scope: Yup.array().required('field_required'),
    }),
    handleSubmit: (values, dispatch, formActions, props) => {
      formActions.onClose = props.onClose;
      const payload = { ...values };
      payload.id = props.data ? props.data.id : null;
      // выкусить fileName
      if (payload.photo && payload.photo.length > 0) {
        payload.photo = payload.photo.split('/download/')[1];
      }
      dispatch({
        type: payload.id
          ? UPDATE_CREDENTIAL.REQUEST
          : CREATE_CREDENTIAL.REQUEST,
        payload,
        formActions,
      });
    },
  },
  CreateCredential
);

CreateCredential.propTypes = {
  visibility: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  handleSubmit: PropTypes.func,
  handleOnChange: PropTypes.func,
  dispatch: PropTypes.func,
  isSubmit: PropTypes.bool,
  values: PropTypes.object,
  errors: PropTypes.object,
  credentials: PropTypes.object,
  data: PropTypes.object,
};

CreateCredential.contextTypes = {
  intl: intlShape,
};

export default injectIntl(FormContactUs);
